import api from "../../axios/api.js";

export class AccountsService {
  async postAccountsLogout(token) {
    const data = await api.post("accounts/logout/", { token: `${token}` }, { headers: { Authorization: `${token}` } });
    return data;
  }
}
